import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'sky-clear-field-button',
  imports: [MatButtonModule, MatIcon],
  templateUrl: './clear-field-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearFieldButtonComponent {
  textLabel = input<string | null>(null);
  clearEvent = output<void>();

  onClear(): void {
    this.clearEvent.emit();
  }
}
